<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import "lodash";
import { BaseAtom } from "components/cards/atoms";
export let container;
</script>

<style></style>

<BaseAtom _isotope="AdSlot" {...container}>
</BaseAtom>
